var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoInverted(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "600.000000pt",
    height: "400.000000pt",
    viewBox: "0 0 600.000000 400.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,400.000000) scale(0.100000,-0.100000)",
    fill: "current",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3290 3193 l-155 -3 3 -963 c2 -529 6 -1029 10 -1112 l7 -150 245 0 245 0 3 1109 c2 881 0 1111 -10 1118 -7 4 -53 7 -103 6 -49 -2 -160 -4 -245 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1668 2954 l-115 -236 428 -865 c236 -476 429 -869 429 -874 0 -5 113 -9 256 -9 201 0 255 3 251 13 -21 52 -1117 2202 -1124 2204 -5 2 -61 -103 -125 -233z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5090 1215 c-139 -140 -251 -258 -247 -261 3 -4 121 -3 262 1 l255 7 0 249 c0 136 -4 250 -8 253 -5 3 -123 -109 -262 -249z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M842 1328 c-82 -156 -182 -355 -182 -363 0 -3 115 -5 255 -5 140 0 255 3 255 6 0 9 -250 494 -255 494 -2 0 -35 -60 -73 -132z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoInverted);
export default __webpack_public_path__ + "static/media/logo-inverted.61308875f4bc8eee0174b1425e81a17e.svg";
export { ForwardRef as ReactComponent };